export default __webpack_public_path__ + "static/dreamcation-bg-9e11fb815051876ab46b3c15368de28b.webp";